import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { Roster } from './interface/roster.interface';
import {Observable} from "rxjs/Observable";

@Injectable()
export class CourseChangeLogService{
    constructor(private http: HttpClient) {}

    save(courseId: any, logData: any): Observable<any> {
        return this.http.post<Roster>('/api/courseChangeLog/' + courseId, { logData: logData });
    }
}
